import styled from 'styled-components/native';

export default styled.View<{ isArtist?: boolean }>`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: ${({ isArtist }) => (isArtist ? 'flex-start' : 'space-between')};
  padding: 15px 15px 6px 15px;
`;
